import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo-nav.png'


const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imperio de Metal",
  class: "h-12 w-auto transition-transform md:h-14 duration-500 group-hover:rotate-[-6deg] group-hover:scale-110"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "hidden items-center gap-10 md:flex" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -bottom-2 left-0 h-px w-full origin-left scale-x-0 bg-gradient-to-r from-copper to-ember transition-transform duration-300 group-hover:scale-x-100" }, null, -1)
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center gap-6 py-8 md:hidden"
}
const _hoisted_9 = ["onClick"]

import { onBeforeUnmount, onMounted, ref } from "vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";
import { scrollToSection } from "@/composables/scrollTo";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarMenu',
  setup(__props) {

const links = [
  { id: "servicios", label: "Servicios" },
  { id: "proceso", label: "Proceso" },
  { id: "galeria", label: "Galería" },
  { id: "contacto", label: "Contacto" },
];

const scrolled = ref(false);
const open = ref(false);

const onScroll = () => (scrolled.value = window.scrollY > 40);

const go = (id: string) => {
  open.value = false;
  scrollToSection(id);
};

onMounted(() => {
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
});
onBeforeUnmount(() => window.removeEventListener("scroll", onScroll));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["fixed inset-x-0 top-0 z-50 transition-all duration-500", 
      scrolled.value || open.value
        ? 'border-b border-copper/10 bg-ink/80 py-3 backdrop-blur-xl'
        : 'py-6'
    ])
  }, [
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_1, [
          _createElementVNode("button", {
            class: "group flex items-center gap-3",
            "aria-label": "Ir al inicio",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (go('inicio')))
          }, _hoisted_3),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
              return _createElementVNode("li", {
                key: link.id
              }, [
                _createElementVNode("button", {
                  class: "group relative text-sm font-semibold uppercase tracking-[0.2em] text-ivory/70 transition-colors hover:text-copper-light",
                  onClick: ($event: any) => (go(link.id))
                }, [
                  _createTextVNode(_toDisplayString(link.label) + " ", 1),
                  _hoisted_6
                ], 8, _hoisted_5)
              ])
            }), 64))
          ]),
          _createElementVNode("button", {
            class: "btn-molten hidden !px-6 !py-3 !text-xs md:inline-flex",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (go('contacto')))
          }, " Cotiza tu pieza "),
          _createElementVNode("button", {
            class: "relative h-10 w-10 md:hidden",
            "aria-expanded": open.value,
            "aria-label": "Abrir menú",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (open.value = !open.value))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["absolute left-2 top-3 h-0.5 w-6 bg-copper transition-all duration-300", open.value && 'top-[19px] rotate-45'])
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["absolute left-2 top-[19px] h-0.5 w-6 bg-copper transition-all duration-300", open.value && 'opacity-0'])
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["absolute left-2 top-[26px] h-0.5 w-6 bg-copper transition-all duration-300", open.value && 'top-[19px] -rotate-45'])
            }, null, 2)
          ], 8, _hoisted_7)
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "opacity-0 -translate-y-4",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-to-class": "opacity-0 -translate-y-4"
    }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
                return _createElementVNode("li", {
                  key: link.id
                }, [
                  _createElementVNode("button", {
                    class: "font-display text-2xl text-ivory hover:text-copper",
                    onClick: ($event: any) => (go(link.id))
                  }, _toDisplayString(link.label), 9, _hoisted_9)
                ])
              }), 64)),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "btn-molten",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (go('contacto')))
                }, " Cotiza tu pieza ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})